// @flow strict

import * as React from "react";
import { UnregisteredRobinHood } from "~robin-hood/unregistered/UnregisteredRobinHood";
import { RegisteredRobinHood } from "~robin-hood/registered/RegisteredRobinHood";
import type { Store } from "~robin-hood/redux/store";
import styles from "./RobinHoodApp.module.css";
import { loadLocalStore, updateLocalStore } from "./localStore";
import classnames from "~common/classnames";

type Props = {};

type State = { store: Store };

export default class RobinHoodApp extends React.Component<Props, State> {
  state: State = { store: loadLocalStore() };

  _updateLocalStore = (updated: Store) => {
    console.log("Updating store to", updated);
    updateLocalStore(updated);
    this.setState({ store: updated });
  };

  render(): React$Node {
    const { store } = this.state;
    return (
      <div
        className={classnames(
          styles.robinHoodApp,
          store.equipo && styles.registered
        )}
      >
        {!store.equipo ? (
          <UnregisteredRobinHood
            store={store}
            updateStore={this._updateLocalStore}
          />
        ) : (
          <RegisteredRobinHood
            store={store}
            updateStore={this._updateLocalStore}
          />
        )}
      </div>
    );
  }
}
